// extracted by mini-css-extract-plugin
module.exports = {"close":"PopupClose_close__aDH69"};